// chakra imports
import {Box, Flex, FormLabel, Input, Stack, Text} from '@chakra-ui/react';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import React from "react";

// FUNCTIONS

function SidebarContent(props: { routes: RoutesType[] }) {
	const { routes } = props;
	// SIDEBAR
	return (
		<Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
			<Brand />
			<Stack direction='column' mt='8px' mb='auto'>
				<Box ps='20px' pe={{ lg: '16px', '2xl': '16px' }}>
					<Links routes={routes} />
				</Box>
			</Stack>
			<div style={{ margin: 12}}>
			<Text style={{fontSize: 16}}>Need Help?</Text>
			<Text style={{fontSize: 14}}><a href="mailto:partners@gamelight.io">partners@gamelight.io</a></Text>
			</div>
		</Flex>
	);
}

export default SidebarContent;
